import { AlertTriangle } from 'lucide-react';
import { formatDateOnlyBR } from '../lib/dateFormat';
import { brl, TIPO_LABEL, MODO_LABEL } from '../lib/recargasExport';

export function RecargasAlertas({ alertas }) {
  if (!alertas?.length) {
    return <p className="text-xs text-emerald-400" data-testid="recargas-sem-alerta">Nenhuma linha com mais de 1 carga/recarga no mesmo mês.</p>;
  }
  return (
    <div className="rounded-sm border border-amber-500/40 bg-amber-500/10 p-3 space-y-2" data-testid="recargas-alertas">
      <p className="text-sm text-amber-300 flex items-center gap-2 font-semibold" data-testid="recargas-alertas-titulo">
        <AlertTriangle className="w-4 h-4" /> {alertas.length} linha(s) com mais de 1 carga/recarga no mesmo mês — confira se a Tip não cobrou a mais
      </p>
      <ul className="space-y-1 max-h-56 overflow-auto text-xs">
        {alertas.map(a => (
          <li key={`${a.iccid}-${a.mes}`} className="text-zinc-200" data-testid={`alerta-${a.iccid}-${a.mes}`}>
            <span className="font-semibold">{a.cliente_nome || 'Sem cliente'}</span> · <span className="font-mono">{a.numero}</span> · {a.mes.split('-').reverse().join('/')}:
            <span className="text-amber-300"> {a.quantidade}x = {brl(a.total)}</span>
            <span className="text-zinc-400"> ({a.eventos.map(e => `${formatDateOnlyBR(e.data)} ${(e.hora || '').slice(0, 5)} ${TIPO_LABEL[e.tipo]} ${MODO_LABEL[e.modo].toLowerCase()}`).join(' | ')})</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
